import { createFileRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';

import { AuthFlowContextProvider } from '@/features/auth/context/auth-flow-context-provider';

export const Route = createFileRoute('/auth')({
  validateSearch: z.object({
    redirectTo: z.string().optional(),
    travelId: z.string().uuid().optional(),
  }),
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <AuthFlowContextProvider>
      <Outlet />
    </AuthFlowContextProvider>
  );
}
